import IconMeta from 'assets/icon-meta.svg?react';
import IconAudienceNetwork from 'assets/icon-audience-network.svg?react';
import IconInstagram from 'assets/icon-instagram.svg?react';
import IconFacebookMessenger from 'assets/facebook-messenger.svg?react';
import IconThreads from 'assets/threads-seeklogo.svg?react';
import type { PublisherPlatform } from '../types';

export const getPlatformIcon = (platform: PublisherPlatform) => {
  switch (platform) {
    case 'facebook':
      return IconMeta;
    case 'audience_network':
      return IconAudienceNetwork;
    case 'instagram':
      return IconInstagram;
    case 'messenger':
      return IconFacebookMessenger;
    case 'threads':
      return IconThreads;
    default:
      return IconMeta;
  }
};
